import { EBOL_STATUS } from '../../../../../../api/types/EbolStatus';
import { EbolDetails, EbolPhoto } from '../../../../../../api/types/EbolDetails';

export enum EBOL_ACTION_REASON {
    MISSING_ITEMS = 'missing_items',
    DAMAGED_GOODS = 'damaged_goods',
    INCORRECT_SHIPMENT = 'incorrect_shipment',
    BLUETOOTH_TAG_BROKEN = 'bluetooth_tag_broken',
    DOCUMENTATION_MISMATCH = 'documentation_mismatch',
    OTHER = 'other',
}

export type EBOL_ACTION_REASON_SOURCE = EBOL_STATUS.REJECTED | EBOL_STATUS.ACCEPTED_WITH_DISCREPANCIES;

export interface EbolActionFormValues {
  reasons: EbolActionReasonOption[];
  photos: EbolPhoto[];
  details?: string;
}

export interface EbolActionReasonOption {
  label: string;
  value: EBOL_ACTION_REASON;
}

export interface EbolActionProps {
  onStatusChange: (ebolDetails: EbolDetails) => void;
  ebolDetails: EbolDetails;
}
